import React from "react";
import SettingsPage from "../../../components/List/SettingsList"
import { useTranslation } from "react-i18next";

const EditItemGroupSettingsPage: React.FC = () => {
    const { t } = useTranslation();
    return (
        <SettingsPage
            title={t("common.itemGroup")}
            fetchUrl= "/itemApi/GetItemGroupList"
            createOrUpdateUrl="itemApi/CreateOrUpdateItemGroup"
            deleteUrl="itemApi/DeleteItemGroup"
        
        />
    );
};

export default EditItemGroupSettingsPage;
